import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);

export const hasRole = (user, ...roles) =>
  user && (roles.length === 0 || roles.includes(user.role));

// Module-level permission helpers. Super admin always has full access.
// If the user has no explicit `module_permissions` the role-default stays in effect.
export const canRead = (user, module) => {
  if (!user) return false;
  if (user.role === "super_admin") return true;
  const m = user.module_permissions?.[module];
  return m?.read !== false; // undefined => inherit default from backend
};

export const canWrite = (user, module) => {
  if (!user) return false;
  if (user.role === "super_admin") return true;
  const m = user.module_permissions?.[module];
  return m?.write === true;
};
